module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag28_1449AT.6e7546e5.jpg";